<!-- src/components/StatusBlock.vue -->

<template>
    <div class="inline-flex space-x-3">
        <span class="uppercase text-sm font-medium" v-if="!!$slots.default"><slot></slot></span>
        <ul class="inline-flex space-x-2">
            <li v-for="option in options">
                <status-block-circle
                    :selected="option.id == currentStatus"
                    :color="option.color"
                    @click="didSelectOption(option)"></status-block-circle>
            </li>
        </ul>
    </div>
</template>

<script>
    
import StatusBlockCircle from './StatusBlockCircle.vue';

export default {
    
    components: { StatusBlockCircle },
    
    props: { 
        currentStatus: {
            default: null
        }, 
        options: {
            default () {
                return []
            }
        }
    },
    
    methods: {
        didSelectOption (option) {
            this.$emit("selected-status", option)
        }
    }
}
</script>
